export default __webpack_public_path__ + "static/media/MyriadProRegular.6c518fcd.OTF";